import { useIntl } from 'react-intl'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Tooltip from 'LuxKit/Tooltip'

function CruiseFlightCreditInfo() {
  const intl = useIntl()

  return <Tooltip
    placement="bottom-start"
    description={intl.formatMessage({
      id: 'TOatLENPidxOczb1NndC',
      defaultMessage: 'Luxury Escapes can help you book flights directly with Princess. Flights cannot be booked through our platform and are only available from 11 months before your sailing return date. Our Concierge team will contact you to help.',
      description: 'Tooltip explaining how customers can use a Princess cruise flight credit after booking',
    })}
  >
    <LineInfoCircleIcon colour="light-foreground-alt" size={14} />
  </Tooltip>
}

export default CruiseFlightCreditInfo
